package diana.soleil.design.iraniancanadienbazzar.core.model

/**
 * One entry in the moderation audit trail (`moderationActions/{id}` — see `docs/DATA_MODEL.md`).
 * Written by an admin or moderator every time they act on reported content, so there is an
 * accountable "who did what to which target, and when" history. Append-only: create by any
 * moderator (stamped with their own uid); no updates or deletes.
 */
data class ModerationAction(
    val id: String,
    /** The moderator/admin who performed the action. */
    val actorUid: String,
    /** What happened — see [ModerationActionType] for the canonical wire values. */
    val action: String,
    /** The moderated content's type (`review`, `post`, `marketplace_item`, `business`, `user`, …). */
    val targetType: String,
    /** The moderated content's id. */
    val targetId: String,
    /** Optional free-text note the actor left (e.g. why they removed or restored it). */
    val reason: String? = null,
    val createdAtMillis: Long? = null,
)

/** Canonical wire values for [ModerationAction.action]. */
enum class ModerationActionType(val wire: String) {
    Remove("remove"),
    Restore("restore"),
    Resolve("resolve"),
    Dismiss("dismiss"),
}
